import styled from 'styled-components'

export const Styled = {
  FieldWrapper: styled.div`
    display: grid;
    gap: 0.5rem;
    max-width: 16.65rem;
  `,
  Block: styled.div`
    margin-top: 0.5rem;
  `,
}
